import fr from 'facet-rest';
import BaseOverride from 'Overrides/Authentication/BaseOverride';
import CheckboxStandardized from 'Components/ComponentLibrary/Components/Uncategorized/Checkbox';

const hiddenFieldNames = [
  'remainingAttempts',
  'sentTo',
];

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride(name => hiddenFieldNames.includes(name), { hidden: true })
  .nameOverride('code', { ordinal: 0 })
  .nameOverride('rememberDevice', { ordinal: 1, _component: CheckboxStandardized })
  .done();
